import {Component, Input} from "@angular/core";
import {NgStyle} from "@angular/common";

@Component({
  selector: 'app-dashboard-project-section',
  templateUrl: './dashboard-project-section.component.html',
  standalone: true,
  imports: [
    NgStyle
  ],
  styleUrl: './dashboard-project-section.component.css'
})

export class DashboardProjectSectionComponent{
  @Input() title!: string;
  @Input() studentValue!: number;
  @Input() icon!: string;
  @Input() iconColor!: string;
  @Input() iconBg!: string;
  @Input() teacherValue!: number;
}
